import { useContext, useEffect, useState } from "react";
import { callAPI } from "utils/API";
import { translate } from "utils/Translate";
import { AppContext } from "contexts/AppContext";
import HorizontalScrollBlock from "components/blocks/horizontalScrollBlock/HorizontalScrollBlock";
import { useNavigate } from "react-router-dom";
import ProductNormal from "components/elements/ProductNormal";
import ButtonMedium4 from "components/elements/ButtonMedium4";
import { setupProductImages } from "utils/productImageHelper";

const ProductsScrollBlock = (props) => {
    const { accessibleShops, langCode } = useContext(AppContext);
    const navigate = useNavigate()
    const [products, setProducts] = useState([])
    const ShopID = accessibleShops && accessibleShops.length > 0 ? accessibleShops[0].ShopID : null

    const fetchProducts = async () => {
        let fetchedProducts = await props.fetchProducts()
        if (!fetchedProducts?.length) return
        fetchedProducts.forEach(product => {            
            setupProductImages(product, false)
        })

        setProducts(fetchedProducts)
    }

    useEffect(() => {
        fetchProducts()
    }, [])

    const seeMoreButton = <ButtonMedium4
        style={{ margin: "auto" }}
        showIcon={false}
        translationKey="_HOME_POPULAR_PRODUCTS_SEE_MORE_BUTTON_"
        fallbackText="Se alle produkter"
        onClick={ShopID ? () => {
            if (props.onSeeMoreClicked) {
                props.onSeeMoreClicked()
            }
            navigate(`shop/${ShopID}`)
        } : null}
    />

    return (
        products.length > 0 &&
        <div>
            <HorizontalScrollBlock category={props.category} caption={props.caption} button={seeMoreButton}>
                {products.map(item => (
                    <ProductNormal
                        key={item.ProductID || item.ProductPackageID}
                        ProductID={item.ProductID}
                        ProductPackageID={item.ProductPackageID}
                        ShopID={item.ShopID}
                        showTag={item.enableDiscount ? true : false}
                        tagOptions={{
                            fallbackText: `${translate('_PRODUCT_DISCOUNT_TAG_TEXT_', 'Spar')} ${Math.round((item.sellingPrice.nonDiscountAmount - item.sellingPrice.amount) / item.sellingPrice.nonDiscountAmount * 100)}%`,
                            showClose: false,
                        }}
                        tagStyles={{ borderRadius: 8 }}
                        price={item.sellingPrice}
                        productReaction={item.reaction}
                        className="productlarge"
                        style={{ boxShadow: `0px 0px 3px 1px rgba(34, 34, 34, 0.15)` }}
                        text2={!!item.translations &&
                            !!item.translations.length
                            ? item.translations.find(
                                (translation) => translation.languageKey === langCode
                            ) ? item.translations.find(
                                (translation) => translation.languageKey === langCode
                            ).elementTitle
                                : item.elementTitle
                            : item.elementTitle}
                        text1={item.manufacturer}
                        imageSrc={`url(${item.image?.src})`}
                        imageBackgroundColor={item.image?.backgroundColor}
                        activityName='home'
                    />
                ))}
            </HorizontalScrollBlock>
        </div>
    )
}

export default ProductsScrollBlock